import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import SkipLink from "@/components/SkipLink";
import RevealOnScroll from "@/components/RevealOnScroll";
import GlobalSearch, { useGlobalSearch } from "@/components/GlobalSearch";
import Header from "@/components/Header";
import BookBanner from "@/components/BookBanner";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ProfilesPage from "@/pages/ProfilesPage";
import ProfilePage from "@/pages/ProfilePage";
import BookPage from "@/pages/BookPage";
import BookReaderPage from "@/pages/BookReaderPage";
import BookLaunchPage from "@/pages/BookLaunchPage";
import ChapterPage from "@/pages/ChapterPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import PodcastPage from "@/pages/PodcastPage";
import ParticipatePage from "@/pages/ParticipatePage";
import ParticipateSuccessPage from "@/pages/ParticipateSuccessPage";
import NominatePage from "@/pages/NominatePage";
import AboutPage from "@/pages/AboutPage";
import YouthPage from "@/pages/YouthPage";
import CoursePage from "@/pages/CoursePage";
import VerifyPage from "@/pages/VerifyPage";
import AdminPage from "@/pages/AdminPage";
import FilmPage from "@/pages/FilmPage";
import SoundtrackPage from "@/pages/SoundtrackPage";
import BookEdition2Page from "@/pages/BookEdition2Page";
import AuthPage from "@/pages/AuthPage";
import CommunityPage from "@/pages/CommunityPage";
import BenefitsPage from "@/pages/BenefitsPage";
import MasterclassesPage from "@/pages/MasterclassesPage";
import EventsPage from "@/pages/EventsPage";
import JobsPage from "@/pages/JobsPage";
import MentorshipPage from "@/pages/MentorshipPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import { AuthProvider } from "@/contexts/AuthContext";

// Wrapper component to use hook
function AppContent() {
  const search = useGlobalSearch();

  return (
    <>
      <SkipLink />
      <ScrollToTop />
      <RevealOnScroll />
      <GlobalSearch isOpen={search.isOpen} onClose={search.close} />
      <Header onSearchClick={search.open} />
      <main id="main-content" className="flex-1" role="main" aria-label="Main content">
        <Routes>
          {/* Home */}
          <Route path="/" element={<HomePage />} />
          
          {/* Profiles / Stories */}
          <Route path="/profiles" element={<ProfilesPage />} />
          <Route path="/profiles/:slug" element={<ProfilePage />} />
          {/* Legacy routes - redirect to new paths */}
          <Route path="/stories" element={<ProfilesPage />} />
          <Route path="/stories/:slug" element={<ProfilePage />} />
          
          {/* Book */}
          <Route path="/book" element={<BookLaunchPage />} />
          <Route path="/book/edition-2" element={<BookEdition2Page />} />
          <Route path="/book/request" element={<BookPage />} />
          <Route path="/book/reader" element={<BookReaderPage />} />
          <Route path="/book/:chapterSlug" element={<ChapterPage />} />
          
          {/* Blog */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:postSlug" element={<BlogPostPage />} />
          
          {/* Podcast */}
          <Route path="/podcast" element={<PodcastPage />} />
          
          {/* Participate */}
          <Route path="/participate" element={<ParticipatePage />} />
          <Route path="/participate/success" element={<ParticipateSuccessPage />} />
          
          {/* Nominate */}
          <Route path="/nominate" element={<NominatePage />} />
          
          {/* Youth Programmes */}
          <Route path="/youth" element={<YouthPage />} />
          <Route path="/youth/course/:courseId" element={<CoursePage />} />
          
          {/* Certificate Verification */}
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/verify/:credentialId" element={<VerifyPage />} />
          
          {/* About */}
          <Route path="/about" element={<AboutPage />} />
          
          {/* Film */}
          <Route path="/film" element={<FilmPage />} />

          {/* Soundtrack */}
          <Route path="/soundtrack" element={<SoundtrackPage />} />

          {/* Community */}
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/benefits" element={<BenefitsPage />} />
          <Route path="/masterclasses" element={<MasterclassesPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/jobs" element={<JobsPage />} />
          <Route path="/mentorship" element={<MentorshipPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />

          {/* Admin */}
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
      <BookBanner />
      <Footer />
      <Toaster position="bottom-right" />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[#FAF9F6]">
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
